const AWS = require("aws-sdk");
const ddb = new AWS.DynamoDB.DocumentClient({
  region: "ap-southeast-1",
 
 
});
const getCurrentLocalDateTime = (myDate = new Date()) => {
  const current = myDate;
  const currentDate = current.toLocaleDateString("th-TH");
  const currentTime = current.toLocaleTimeString("th-TH");
  const splitDate = currentDate.split("/");
  const splitTime = currentTime.split(":");
  const date = splitDate[0];
  const month = splitDate[1];
  const year = +splitDate[2] - 543;
  const hours = splitTime[0];
  const minutes = splitTime[1];
  const seconds = splitTime[2];
  const day = new Date(
    year,
    +month - 1,
    +date,
    +hours,
    +minutes,
    +seconds
  ).getDay();
  const timestamp = new Date(
    year,
    +month - 1,
    +date,
    +hours,
    +minutes,
    +seconds
  ).getTime();
  const currentFormatLocalDate =
    pad(year) +
    "-" +
    pad(month) +
    "-" +
    pad(date) +
    "T" +
    pad(hours) +
    ":" +
    pad(minutes) +
    ":" +
    pad(seconds) +
    "." +
    (current.getMilliseconds() / 1000).toFixed(3).slice(2, 5);
  let fullDate = `${year}-${pad(+month)}-${pad(date)}`;
  return {
    fullDate,
    day,
    date,
    month,
    monthIndex: month - 1,
    year,
    hours,
    minutes,
    seconds,
    timestamp,
    isoDateTime: currentFormatLocalDate,
  };
};

const pad = (number) => {
  if (parseInt(number) < 10) {
    return "0" + parseInt(number);
  }
  return number;
};

const isLeapyear = leapYear(new Date().getFullYear());
const FABRUARY_DAYS = isLeapyear ? 29 : 28;

function leapYear(year) {
  return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
}

const months = [
  { month: "January", days: 31, index: 0, monthTh: "มกราคม" },
  { month: "February", days: FABRUARY_DAYS, index: 1, monthTh: "กุมภาพันธ์" },
  { month: "March", days: 31, index: 2, monthTh: "มีนาคม" },
  { month: "April", days: 30, index: 3, monthTh: "เมษายน" },
  { month: "May", days: 31, index: 4, monthTh: "พฤษภาคม" },
  { month: "June", days: 30, index: 5, monthTh: "มิถุนายน" },
  { month: "July", days: 31, index: 6, monthTh: "กรกฎาคม" },
  { month: "August", days: 31, index: 7, monthTh: "สิงหาคม" },
  { month: "September", days: 30, index: 8, monthTh: "กันยายน" },
  { month: "October", days: 31, index: 9, monthTh: "ตุลาคม" },
  { month: "November", days: 30, index: 10, monthTh: "พฤศจิกายน" },
  { month: "December", days: 31, index: 11, monthTh: "ธันวาคม" },
];

function differenceInDays(date1, date2) {
  var difference = date1.getTime() - date2.getTime();

  var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);

  return daysDifference;
}

export const calcuratorInterestTwo = (loan, { where, dataInterest }) => {
  const today = getCurrentLocalDateTime(new Date(where.paid_date));
  let newItem = { ...loan };
  const {
    installments,
    type,
    promo: loanPromo = 0,
    capitalRemain,
    initCapital,
    interestMore = 0,
    overflow,
    evidence = [],
  } = newItem;
  let newInterestMore = 0;
  let newPrincipleMore = 0;
  let checkPrincipleMore = false;
  let checkInterestMore = false;
  let checkOverflow = false;
  let checkCapital = false;
  let newCapital = initCapital;
  let lastIndex = installments.length - 1;
  let prevOverflow = 0;
  let cal_index = 0;
  let total_penalty = 0;
  let check_penalty = false;
  let last_penalty = 0;
  let total_late = 0;
  let check_late = false;
  let total_penalty_all = 0;

  let keep_penalty = 0;
  let keep_late = 0;
  let keep_late_interest = 0;
  let self_keep_late = 0;
  let self_keep_late_interest = 0;
  let last_keep_late = 0;
  let last_add_penalty = 0;
  let check_last_penalty = false;
  let stack_penalty = [];
  let keep_overflow = 0;

  let cal_capital_overflow = initCapital;
  let check_remain = false;
  // console.log("first");
  if (overflow > 0) {
    // console.log("in overflow");

    let cal_diff_overflow = overflow;
    for (let index = installments.length - 1; index >= 0; index--) {
      // วนลูปจากงวดท้าย
      const last_installment = installments[index]; // ค่างวดล่าสุด
      let principle_remain = last_installment.actualCapitalRemain - overflow; // หาเงินต้นจากการโปะ
      let checkPeriod = today.fullDate <= last_installment.date;

      if (
        last_installment.disabledPeriod &&
        last_installment.paid_amount === 0
      ) {
        if (principle_remain < 0) {
          last_installment.planCapitalRemain = 0;
        }
      }

      if (
        !last_installment.disabledPeriod &&
        checkPeriod &&
        last_installment.paid_amount === 0
      ) {
        if (principle_remain < 0) {
          last_installment.planCapitalRemain = 0;
        } else {
          last_installment.planCapitalRemain = principle_remain;
        }
      }
    }
  }

  for (let index = 0; index < installments.length; index++) {
    let installment = installments[index];

    let INTEREST_RATE_TYPE = dataInterest.Items.find(
      (item) => item.type === type
    );

    const promo = loanPromo || 0;
    let INTEREST_PROMO = +INTEREST_RATE_TYPE.value + promo;
    let INTEREST_RATE = +INTEREST_PROMO < 15 ? 15 / 100 : +INTEREST_PROMO / 100;

    let checkDate = today.fullDate > installment.date;
    let checkPeriod = today.fullDate <= installment.date;

    let prevIndex = index === 0 ? 0 : index - 1;

    let total_period = installment.actualInterest + installment.actualPrinciple;
    if (installment.disabledPeriod && total_period === 0) {
      cal_index++;
    }

    let total_plan = installment.planPrinciple + installment.planInterest;
    let prev_total_plan =
      installments[prevIndex].planPrinciple +
      installments[prevIndex].planInterest;
    let total_actual = installment.actualPrinciple + installment.actualInterest;

    if (installment.actualPrinciple > installment.planPrinciple) {
      let cal_actual_principle =
        installment.actualPrinciple - installment.planPrinciple;
      installment.actualPrinciple = installment.planPrinciple;
      let prevIndex = index;
      do {
        prevIndex--;
        if (prevIndex < 0) {
          break;
        }

        if (cal_actual_principle > 0) {
          if (cal_actual_principle >= installments[prevIndex].planPrinciple) {
            installments[prevIndex].actualPrinciple =
              installments[prevIndex].planPrinciple;
          } else {
            installments[prevIndex].actualPrinciple = cal_actual_principle;
          }
          cal_actual_principle -= installments[prevIndex].planPrinciple;
        }
      } while (cal_actual_principle > 0);
    }

    if (installment.interestMore > 0) {
      let cal_actual_interest = installment.interestMore;
      let prevIndex = index;
      do {
        prevIndex--;
        if (prevIndex < 0) {
          break;
        }

        if (cal_actual_interest > 0) {
          if (cal_actual_interest > installment.planInterest) {
            // console.log("1");
            installments[prevIndex].actualInterest = installment.planInterest;
          } else {
            // console.log("2");
            installments[prevIndex].actualInterest = cal_actual_interest;
          }
          cal_actual_interest -= installments[prevIndex].planInterest;
        }
      } while (cal_actual_interest > 0);
    }

    let {
      paid_amount: prev_paid_amount,
      planPrinciple: prevPlanPrinciple,
      planInterest: prevPlanInterest,
      planCapitalRemain: prevPlanCapitalRemain,
      penalty: prevPenalty,
      overflow: prevOverflow,
      disabledPeriod: prevDisablePeriod,
      interestMore: prevInterestMore,
      actualInterest: prevActualInterest,
      actualPrinciple: prevActualPrinciple,
      isPenalty: prevIsPenalty = false,
      isLastAddPenalty: prevIsLastAddPenalty = false,
    } = installments[prevIndex];

    let nextIndex = index + 1 < installments.length ? index + 1 : index;

    newCapital = prevPlanCapitalRemain - installment.planPrinciple;

    if (overflow > 0) {
      // console.log("in overflow", overflow);
      // console.log("keep_overflow", keep_overflow);
    }

    if (checkDate && !installment.disabledPeriod) {
      installment.disabledPeriod = true;
      if (installment.paid_amount === 0) {
        newCapital = capitalRemain;
      } else {
        // console.log("enabled");
        newCapital = installment.planCapitalRemain;
      }
    } else {
      if (!checkCapital && checkPeriod && !installment.disabledPeriod) {
        if (installment.paid_amount > 0) {
          newCapital = installment.planCapitalRemain;
        } else {
          newCapital = capitalRemain;
        }
        checkCapital = true;
      } else {
        if (!installment.disabledPeriod) {
          newCapital = installment.planCapitalRemain - keep_overflow;
        } else {
          newCapital = installment.planCapitalRemain;
        }
      }
    }

    if (installment.date > checkPeriod) {
      newCapital = installment.planCapitalRemain - keep_overflow;
    }

    if (
      installment.disabledPeriod &&
      installment.actualPrinciple + installment.actualInterest > 0
    ) {
      installment.displayStatus = "ค้างชำระ";
    }

    if (newCapital < 0) {
      newCapital = 0;
    }

    if (installment.planCapitalRemain === 0) {
      newCapital = 0;
    }

    installment.planCapitalRemain = newCapital;

    let interest = ((newCapital * INTEREST_RATE) / 365) * installment.days;
    installment.planInterest = Math.ceil(Number(interest));
    //   if (installment.paid_interest) {
    //     installment.actualInterest = Math.ceil(
    //       Number(installment.actualInterest)
    //     );
    //   }
    if (
      !installment.paid_interest &&
      installment.actualInterest === 0 &&
      installment.disabledPeriod
    ) {
      installment.actualInterest = 0;
      installment.paid_interest = true;
    }

    if (!installment.paid_interest) {
      installment.actualInterest = Math.ceil(Number(interest));
    } else if (
      installment.paid_amount > 0 ||
      installment.overflow ||
      installment.actualInterest === 0
    ) {
      installment.actualInterest = installment.actualInterest;
    }
    //  else {
    //     installment.actualInterest = installment.actualInterest;
    //   }
  }

  let countDisabled = 0;
  installments.forEach((installment) => {
    let checkPeriod = today.fullDate <= installment.date;

    if (installment.disabledPeriod) {
      countDisabled++;
      if (countDisabled !== installments.length) {
        newInterestMore += installment.actualInterest;
      }
    }

    if (checkPeriod && !checkInterestMore) {
      installment.interestMore = newInterestMore;
      checkInterestMore = true;
    }
  }, 0);

  if (countDisabled === installments.length) {
    installments[installments.length - 1].interestMore = newInterestMore;
  }

  // console.log("newInterestMore", newInterestMore);

  newItem.interestMore = newInterestMore;

  return newItem;
};

export const updateInstallmentsTwo = async (
  installments,
  {
    paid_amount: paid_amountRaw = 0,
    overflow,
    capitalRemain,
    paid_date,
    phone_number,
    interestMore,
    period,
    requestamount,
    loan_status,
  }
) => {
  const today = getCurrentLocalDateTime(new Date(paid_date));
  let updateOverflow = Math.ceil(overflow);

  let updateInstallments = [...installments];
  let updateCapitalRemain = +capitalRemain;
  let updateInterestMore = interestMore;
  let checkOverdue = false;
  let overdueDate = "";
  let rawPaidAmount = paid_amountRaw;
  let paid_amount = paid_amountRaw;
  let currentInstallment = installments[0];
  let currentPriciple = installments[0].planPrinciple;
  let currentPeriod = installments.every(
    (installment) => installment.disabledPeriod
  )
    ? installments.length
    : 1;
  let paidAmountInterestMore = 0;
  let updated_paid_interest = 0;
  let updated_paid_principle = 0;
  let updated_paid_interestMore = 0;
  let updated_paid_overflow = 0;
  let paid_amount_remain = paid_amount;
  let installmentNumber = "";
  let relate_period = [];
  // let checkOverflow = false

  for (let index = 0; index < installments.length; index++) {
    const installment = installments[index];

    let check_paid_principle = false;
    let check_paid_interest = false;

    //   console.log("index", index);
    //   console.log("installment", installment);

    let checkPeriod = today.fullDate <= installment.date;
    updateInstallments[index].interestMore = 0;
    // updateInterestMore = 0;

    let receiveInterest = 0;
    if (installment.actualInterest > 0 && paid_amount_remain > 0) {
      paid_amount_remain -= installment.actualInterest;
      check_paid_interest = true;
      if (paid_amount_remain < 0) {
        receiveInterest =
          installment.actualInterest - Math.abs(paid_amount_remain);
        installment.actualInterest = Math.abs(paid_amount_remain);
      } else {
        receiveInterest = installment.actualInterest;
        installment.actualInterest = 0;
      }

      updateInstallments[index].receiveInterest += receiveInterest;
      updateInstallments[index].actualInterest = installment.actualInterest;
      updateInstallments[index].paid_interest = true;
      if (installment.disabledPeriod) {
        updated_paid_interestMore += receiveInterest;
      } else {
        updated_paid_interest += receiveInterest;
      }

      // const paramsProfile = {
      //   TableName: "profile",
      //   Key: {
      //     phone_number,
      //   },
      // };

      // const resultProfile = await ddb.get(paramsProfile).promise();

      // if (resultProfile.Item) {
      //   const paramsPoint = {
      //     TableName: "point_table",
      //   };

      //   const resultPoint = await ddb.scan(paramsPoint).promise();

      //   const pointPay = resultPoint.Items.find(
      //     (point) => point.type === "pay"
      //   );

      //   const profile = resultProfile.Item;

      //   const paramsUpdateProfile = {
      //     TableName: "profile",
      //     Key: {
      //       phone_number,
      //     },
      //     ConditionExpression: "phone_number = :phone_number",
      //     UpdateExpression: "set point = :point",
      //     ExpressionAttributeValues: {
      //       ":point":
      //         Math.floor(parseInt(receiveInterest / +pointPay.value)) +
      //         parseInt(profile.point),
      //       ":phone_number": phone_number,
      //     },
      //     ReturnValues: "UPDATED_NEW",
      //   };

      //   await ddb.update(paramsUpdateProfile).promise();
      // }
    }

    let receivePrinciple = 0;
    if (installment.actualPrinciple > 0 && paid_amount_remain > 0) {
      paid_amount_remain -= installment.actualPrinciple;
      check_paid_principle = true;
      if (paid_amount_remain < 0) {
        receivePrinciple =
          installment.actualPrinciple - Math.abs(paid_amount_remain);
        installment.actualPrinciple = Math.abs(paid_amount_remain);
      } else {
        receivePrinciple = installment.actualPrinciple;
        installment.actualPrinciple = 0;
      }
      updateCapitalRemain -= receivePrinciple;
      updated_paid_principle += receivePrinciple;
      updateInstallments[index].actualCapitalRemain = updateCapitalRemain;
      updateInstallments[index].actualPrinciple = installment.actualPrinciple;
    }

    if (
      installment.actualPrinciple === 0 &&
      installment.actualInterest === 0 &&
      !checkPeriod &&
      installment.displayStatus !== "ปิด-ตรงเวลา"
    ) {
      updateInstallments[index].displayStatus = "ปิด-เลท";
    }

    // console.log("check_paid_interest", check_paid_interest);
    // console.log("check_paid_principle", check_paid_principle);
    // console.log("paid_amount_remain", paid_amount_remain);

    if (check_paid_interest || check_paid_principle) {
      installmentNumber += `${pad(index + 1)},`;
      relate_period.push(`${pad(index + 1)}`);
    }

    if (checkPeriod) {
      currentInstallment = updateInstallments[index];
      currentPeriod = index + 1;
      const prevIndex = index - 1;
      const checkOverflow = paid_amount_remain > 0;
      const newOverflow = paid_amount_remain;
      let checkUpdate = false;

      updateInstallments[index].paid_date = paid_date;
      updateInstallments[index].paid_amount += paid_amount;

      if (
        installment.actualInterest === 0 &&
        installment.actualPrinciple === 0
      ) {
        updateInstallments[index].disabledPeriod = true;
        updateInstallments[index].displayStatus = "ปิด-ตรงเวลา";
      }

      let nextPrinciple = 0;
      if (checkOverflow) {
        let indeXOverflow = index;
        updateCapitalRemain -= newOverflow;
        updateInstallments[indeXOverflow].paid_overflow = true;
        updateInstallments[indeXOverflow].overflow += newOverflow;
        updateOverflow += +newOverflow;
        updated_paid_overflow += +newOverflow;

        for (let jedex = installments.length - 1; jedex > 0; jedex--) {
          let lastInstallment = installments[jedex]; //ดึงตัวสุดท้าย
          let lastPrinciple =
            lastInstallment.actualPrinciple -
            (nextPrinciple < 0
              ? Math.abs(nextPrinciple)
              : Math.floor(newOverflow)); //ถ้าเงินต้นลบ overflow แล้วน้อยกว่า 0 จะดึง nextPrinciple ไปลบงวดย้อนถัดไป ถ้าไม่ใช่จะลบ overflow ปกติและตำแหน่งเดิมของงวดท้ายนั้น

          // console.log("lastPrinciple", lastPrinciple);
          // console.log("jedex", jedex);
          // console.log("checkPeriod", checkPeriod);
          if (lastInstallment.disabledPeriod) {
            continue;
          }

          if (!checkPeriod) {
            //   console.log("break");
            break;
          }

          installmentNumber += `${pad(jedex + 1)},`;
          relate_period.push(`${pad(index + 1)}`);

          if (lastPrinciple === 0) {
            //ถ้าตัวสุดท้ายเหลือ 0
            //   console.log("1");
            updateInstallments[jedex].disabledPeriod = true;
            updateInstallments[jedex].actualPrinciple = 0;
            updateInstallments[jedex].planCapitalRemain = 0;
            updateInstallments[jedex].displayStatus = "ปิด-โปะ";
            updateInstallments[jedex].actualInterest = 0;
            updateInstallments[jedex].paid_overflow = true;
            updateInstallments[jedex].planInterest = 0;
            break;
          } else if (lastPrinciple > 0) {
            //มากกว่า 0 break หยุด loop
            //   console.log("2");
            updateInstallments[jedex].actualPrinciple =
              Math.floor(lastPrinciple);
            // updateInstallments[jedex].planCapitalRemain =
            //   Math.floor(lastPrinciple);
            break;
          } else if (lastPrinciple < 0) {
            //   console.log("3");
            //น้อยกว่า 0 loop รอบถัดไป เช่น งวด 12 > 11
            updateInstallments[jedex].disabledPeriod = true;
            updateInstallments[jedex].actualPrinciple = 0;
            updateInstallments[jedex].actualInterest = 0;
            updateInstallments[jedex].displayStatus = "ปิด-โปะ";
            updateInstallments[jedex].planCapitalRemain = 0;
            updateInstallments[jedex].paid_overflow = true;
            updateInstallments[jedex].planInterest = 0;
            nextPrinciple = Math.floor(lastPrinciple);
          }
        }
      }
      break;
    }
  }

  const includeCapitalRemainOverflow = updateCapitalRemain + updateOverflow;

  const installmentDateIndex = Math.round(
    (requestamount - includeCapitalRemainOverflow) / currentPriciple
  );

  const lastInstallment = installments[installments.length - 1];
  if (
    lastInstallment.actualPrinciple +
      lastInstallment.actualInterest +
      lastInstallment.interestMore >
    0
  ) {
    const last_total =
      lastInstallment.actualPrinciple +
      lastInstallment.actualInterest +
      lastInstallment.interestMore;
    const cal_last_paid = last_total - lastInstallment.paid_amount;
  }

  // console.log("updateCapitalRemain", updateCapitalRemain);
  // console.log("updateOverflow", updateOverflow);
  // console.log("installmentDateIndex", installmentDateIndex);
  // console.log("updated_paid_interest", updated_paid_interest);
  // console.log("updated_paid_interestMore", updated_paid_interestMore);
  // console.log("updated_paid_principle", updated_paid_principle);
  // console.log("update_interest_more", updateInterestMore);

  overdueDate =
    installments[
      installmentDateIndex >= installments.length
        ? installments.length - 1
        : installmentDateIndex
    ].date;

  return {
    updated_paid_interest,
    updated_paid_interestMore,
    updated_paid_principle,
    updated_paid_overflow,
    checkOverdue, //ของเก่า
    overdueDate,
    currentPeriod,
    currentInstallment,
    interestMore: updateInterestMore < 0 ? 0 : updateInterestMore,
    installments: updateInstallments,
    capitalRemain: updateCapitalRemain,
    overflow: +updateOverflow,
    paidAmountInterestMore,
    installmentNumber,
    relate_period,
  };
};

export const calTempInstallments = async (data) => {
  let completedAt = getCurrentLocalDateTime(new Date(data.requestTime)).date;
  let promo = 0;
  if (data.promo != undefined) promo = +data.promo;
  let initCapital = data.requestamount;
  let capital = initCapital;
  let installments = [];

  let paramsInterest = {
    TableName: "interest",
  };

  let interest = await ddb.scan(paramsInterest).promise();

  let INTEREST_RATE_TYPE = interest.Items.find(
    (item) => item.type === data.type
  );

  promo = +promo || 0;
  let INTEREST_PROMO = +INTEREST_RATE_TYPE.value + promo;
  let INTEREST_RATE = +INTEREST_PROMO < 15 ? 15 / 100 : +INTEREST_PROMO / 100;

  let now = new Date(data.requestTime);
  let principle = Math.ceil(initCapital / data.period);
  let today = getCurrentLocalDateTime(now);
  let nextIndex = today.monthIndex + 1 === 12 ? 0 : today.monthIndex + 1;
  let checkNextDate = +months[nextIndex].days - +today.date < 0;
  let nextDateTime = getCurrentLocalDateTime(
    new Date(
      nextIndex === 0 ? today.year + 1 : today.year,
      today.monthIndex + 1,
      checkNextDate ? +months[nextIndex].days : today.date
    )
  );
  let year = nextIndex === 0 ? today.year + 1 : today.year;
  let currentMonthIndex = today.monthIndex;
  let monthIndex = nextDateTime.monthIndex;
  for (let i = 0; i < data.period; i++) {
    if (monthIndex === 12) {
      monthIndex = 0;
      currentMonthIndex = 11;
      year += 1;
    }
    if (currentMonthIndex === 12) {
      currentMonthIndex = 0;
    }

    let interest =
      ((+capital * INTEREST_RATE) / 365) * +months[currentMonthIndex].days;

    let currentDate = +completedAt;
    if (currentDate > +months[monthIndex].days) {
      currentDate -= +completedAt - +months[monthIndex].days;
    }
    let principleRemain = Math.abs(principle - capital - principle);
    let checkCapital = i === data.period - 1;
    let originalPrinciple = principle;
    principle = checkCapital ? principleRemain : principle;
    installments.push({
      actualInterest: Math.ceil(Number(interest)),
      planInterest: Math.ceil(Number(interest)),
      actualPrinciple: Math.ceil(Number(principle)),
      planCapitalRemain: Math.ceil(Number(capital)),
      actualCapitalRemain: Math.ceil(Number(capital)),
      planPrinciple: Math.ceil(Number(principle)),
      days: +months[currentMonthIndex].days,
      date: `${year}-${pad(monthIndex + 1)}-${pad(currentDate)}`,
      paid_date: "-",
    });
    capital = capital - principle;
    currentMonthIndex++;
    monthIndex++;
  }
  return installments;
};
